(function () {
  function toText(value) {
    if (value === null || value === undefined) return "";
    return String(value).trim();
  }

  function toNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function escapeHtml(value) {
    return toText(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildFreshUrl(rawUrl) {
    var url = toText(rawUrl);
    if (!url) return "";

    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("_ts", String(Date.now()));
      return parsed.toString();
    } catch (error) {
      var joiner = url.indexOf("?") === -1 ? "?" : "&";
      return url + joiner + "_ts=" + Date.now();
    }
  }

  function normalizeStore(item, index) {
    if (!item || typeof item !== "object") return null;

    var lat = toNumber(item.lat);
    var lng = toNumber(item.lng);
    if (lat === null || lng === null) return null;

    return {
      id: toText(item.id) || "store-" + index,
      store_type: toText(item.store_type),
      store_name: toText(item.store_name),
      country: toText(item.country),
      city: toText(item.city),
      address: toText(item.address),
      lat: lat,
      lng: lng,
      google_maps_url: toText(item.google_maps_url),
      image_url: toText(item.image_url || item.image || item.logo || ""),
    };
  }

  function getStoreTypeName(store) {
    var type = toText(store.store_type).toLowerCase();
    if (type === "marmoris store") return "marmoris";
    if (type === "flagship store") return "flagship";
    if (type === "authorized reseller") return "authorized";
    return null;
  }

  function buildStoreType(store) {
    var templateName = getStoreTypeName(store);
    if (!templateName) return null;

    var templatesRoot = document.querySelector("[data-store-type-templates]");
    if (!templatesRoot) {
      return buildStoreTypeFallback(templateName);
    }

    var source = templatesRoot.querySelector(
      '[data-store-type-template="' + templateName + '"]',
    );
    if (!source) {
      return buildStoreTypeFallback(templateName);
    }

    return source.cloneNode(true);
  }

  function buildStoreTypeFallback(templateName) {
    var wrap = document.createElement("div");
    wrap.className = "store-type";

    if (templateName === "authorized") {
      wrap.innerHTML =
        '<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.29189 10.3323C2.11133 10.3323 1.94657 10.2781 1.79762 10.1698C1.64866 10.0615 1.55161 9.91702 1.50647 9.73646L0.0168869 4.34687C-0.0192233 4.22047 0.0025788 4.10312 0.0822932 3.99479C0.161918 3.88646 0.271018 3.83229 0.409595 3.83229H3.14501L5.65022 0.176042C5.69537 0.121875 5.74501 0.0789939 5.79918 0.0473958C5.85335 0.0157977 5.91653 0 5.98876 0C6.06099 0 6.12418 0.0157977 6.17835 0.0473958C6.23251 0.0789939 6.28216 0.121875 6.3273 0.176042L8.81897 3.83229H11.6086C11.7471 3.83229 11.8562 3.88646 11.9359 3.99479C12.0156 4.10312 12.0374 4.22047 12.0013 4.34687L10.4981 9.73646C10.453 9.91702 10.356 10.0615 10.207 10.1698C10.058 10.2781 9.89329 10.3323 9.71272 10.3323H2.29189ZM2.29189 9.51979H9.71272L11.0804 4.64479H0.93772L2.29189 9.51979ZM6.00474 7.89479C6.2288 7.89479 6.41985 7.81497 6.57782 7.65537C6.7358 7.49585 6.8148 7.30402 6.8148 7.07985C6.8148 6.85579 6.73499 6.66475 6.57539 6.50677C6.41587 6.34879 6.22403 6.26979 5.99987 6.26979C5.77581 6.26979 5.58476 6.3496 5.42678 6.50921C5.26881 6.66873 5.1898 6.86056 5.1898 7.08473C5.1898 7.30879 5.26962 7.49983 5.42922 7.65781C5.58874 7.81579 5.78057 7.89479 6.00474 7.89479ZM4.13355 3.83229H7.83043L5.98876 1.12396L4.13355 3.83229Z" fill="black"/></svg><div>Authorized Reseller</div>';
      return wrap;
    }

    if (templateName === "flagship") {
      wrap.innerHTML =
        '<div class="store-type-badge">Flagship Store</div>';
      return wrap;
    }

    wrap.innerHTML =
      '<svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12" height="18" rx="2" fill="#000"/></svg><div>Marmoris Store</div>';
    return wrap;
  }

  function parseStores(payload) {
    var rows = [];

    if (typeof payload === "string") {
      try {
        payload = JSON.parse(payload);
      } catch (error) {
        return [];
      }
    }

    if (Array.isArray(payload)) {
      rows = payload;
    } else if (payload && Array.isArray(payload.stores)) {
      rows = payload.stores;
    }

    return rows.map(normalizeStore).filter(Boolean);
  }

  function uniqueValues(rows, key) {
    var found = new Set();

    rows.forEach(function (row) {
      var value = toText(row[key]);
      if (value) found.add(value);
    });

    return Array.from(found).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function setOptions(selectEl, values) {
    var current = selectEl.value || "all";

    selectEl.innerHTML = "";

    var allOption = document.createElement("option");
    allOption.value = "all";
    allOption.textContent = "All";
    selectEl.appendChild(allOption);

    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      selectEl.appendChild(option);
    });

    if (
      [].slice.call(selectEl.options).some(function (opt) {
        return opt.value === current;
      })
    ) {
      selectEl.value = current;
    } else {
      selectEl.value = "all";
    }
  }

  function buildCard(store, index) {
    var article = document.createElement("article");
    article.className = "our-store-card";
    article.dataset.storeCard = "1";
    article.dataset.storeId = store.id;

    var left = document.createElement("div");
    left.className = "inner-left";

    var name = document.createElement("h3");
    name.className = "our-store-card__title";
    name.textContent = store.store_name || "Unknown Store";

    var city = document.createElement("h4");
    city.className = "our-store-card__city";
    city.textContent = store.city || "-";

    var storeType = buildStoreType(store);
    if (storeType) {
      left.appendChild(storeType);
    }
    left.appendChild(name);
    left.appendChild(city);

    var right = document.createElement("div");
    right.className = "inner-right";

    var address = document.createElement("p");
    address.className = "our-store-card__address";
    address.textContent = store.address || "-";

    var link = document.createElement("a");
    link.className = "our-store-card__map-link";
    link.innerHTML =
      "Google Maps" +
      '<svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8536 4.03556C17.0488 3.8403 17.0488 3.52372 16.8536 3.32845L13.6716 0.146473C13.4763 -0.0487893 13.1597 -0.0487893 12.9645 0.146473C12.7692 0.341735 12.7692 0.658318 12.9645 0.85358L15.7929 3.68201L12.9645 6.51043C12.7692 6.7057 12.7692 7.02228 12.9645 7.21754C13.1597 7.4128 13.4763 7.4128 13.6716 7.21754L16.8536 4.03556ZM0 3.68201V4.18201H16.5V3.68201V3.18201H0V3.68201Z" fill="#DC4716"/></svg>';
    link.href =
      store.google_maps_url ||
      "https://www.google.com/maps?q=" + store.lat + "," + store.lng;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    right.appendChild(address);
    right.appendChild(link);

    article.appendChild(left);
    article.appendChild(right);

    if (index === 0) {
      article.classList.add("is-active");
    }

    return article;
  }

  function createMarkerElement(store) {
    var el = document.createElement("div");
    var storeTypeName = getStoreTypeName(store);
    el.className = "our-store-marker-icon";
    if (storeTypeName) {
      el.classList.add("our-store-marker-icon--" + storeTypeName);
    }
    el.innerHTML = "<span></span>";
    return el;
  }

  function init() {
    var root = document.querySelector("[data-our-stores-root]");
    if (!root) return;
    if (typeof maplibregl === "undefined") return;

    var apiUrl = toText(root.dataset.apiUrl);
    var mapEl = root.querySelector("#our-stores-map");
    var filterGroups = [].slice.call(
      root.querySelectorAll("[data-filter-group]"),
    );
    var countryFilters = filterGroups
      .map(function (group) {
        return group.querySelector("[data-country-filter]");
      })
      .filter(Boolean);
    var cityFilters = filterGroups
      .map(function (group) {
        return group.querySelector("[data-city-filter]");
      })
      .filter(Boolean);
    var countEls = filterGroups
      .map(function (group) {
        return group.querySelector("[data-results-count]");
      })
      .filter(Boolean);
    var cardsEl = root.querySelector("[data-store-cards]");
    var feedbackEl = root.querySelector("[data-feedback]");
    var activeCountry = "all";
    var activeCity = "all";

    if (
      !apiUrl ||
      !mapEl ||
      !countryFilters.length ||
      !cityFilters.length ||
      !countEls.length ||
      !cardsEl ||
      !feedbackEl
    ) {
      return;
    }

    var defaultCenter = [100.99, 15.87];
    var defaultZoom = 12;
    var map = new maplibregl.Map({
      container: mapEl,
      style: "https://tiles.openfreemap.org/styles/liberty",
      center: defaultCenter,
      zoom: defaultZoom,
      cooperativeGestures: true,
    });

    map.addControl(new maplibregl.NavigationControl(), "top-left");

    function ResetControl() {}
    ResetControl.prototype.onAdd = function () {
      var container = document.createElement("div");
      container.className = "maplibregl-ctrl maplibregl-ctrl-group";

      var button = document.createElement("button");
      button.type = "button";
      button.className = "our-stores-reset-map";
      button.setAttribute("aria-label", "Reset map");
      button.textContent = "↺";
      button.addEventListener("click", function () {
        map.flyTo({
          center: defaultCenter,
          zoom: defaultZoom,
          essential: true,
        });
      });

      container.appendChild(button);
      this._container = container;
      return this._container;
    };
    ResetControl.prototype.onRemove = function () {
      if (this._container && this._container.parentNode) {
        this._container.parentNode.removeChild(this._container);
      }
      this._container = null;
    };
    map.addControl(new ResetControl(), "top-left");

    var stores = [];
    var filteredStores = [];
    var activeStoreId = null;
    var markersById = new Map();

    function fetchStores(url) {
      return fetch(buildFreshUrl(url), {
        method: "GET",
        cache: "no-store",
        headers: {
          Accept: "application/json",
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
        },
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Store request failed");
        }

        return response.json();
      });
    }

    function setFeedback(message) {
      if (!message) {
        feedbackEl.hidden = true;
        feedbackEl.textContent = "";
        return;
      }

      feedbackEl.hidden = false;
      feedbackEl.textContent = message;
    }

    function setFiltersDisabled(disabled) {
      countryFilters.concat(cityFilters).forEach(function (selectEl) {
        selectEl.disabled = !!disabled;
      });
    }

    function renderLoadingCards() {
      cardsEl.innerHTML = "";

      for (var i = 0; i < 3; i += 1) {
        var card = document.createElement("article");
        var innerLeft = document.createElement("div");
        var innerRight = document.createElement("div");

        card.className = "our-store-card our-store-card--skeleton";
        innerLeft.className = "inner-left";
        innerRight.className = "inner-right";

        innerLeft.innerHTML =
          '<div class="skeleton-line skeleton-line--sm"></div>' +
          '<div class="skeleton-line skeleton-line--lg"></div>' +
          '<div class="skeleton-line skeleton-line--md"></div>';
        innerRight.innerHTML =
          '<div class="skeleton-line skeleton-line--lg"></div>' +
          '<div class="skeleton-line skeleton-line--md"></div>';

        card.appendChild(innerLeft);
        card.appendChild(innerRight);
        cardsEl.appendChild(card);
      }
    }

    function setLoadingState(isLoading) {
      root.classList.toggle("is-loading", !!isLoading);
      setFiltersDisabled(isLoading);

      if (isLoading) {
        setFeedback("");
        renderLoadingCards();
        return;
      }

      cardsEl.innerHTML = "";
    }

    function setActiveCard(storeId) {
      activeStoreId = storeId;
      var cards = cardsEl.querySelectorAll("[data-store-card]");

      cards.forEach(function (card) {
        card.classList.toggle("is-active", card.dataset.storeId === storeId);
      });
    }

    function scrollToCard(storeId) {
      var card = null;
      var cards = cardsEl.querySelectorAll("[data-store-card]");

      cards.forEach(function (item) {
        if (!card && item.dataset.storeId === storeId) {
          card = item;
        }
      });

      if (!card) return;

      card.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
      setActiveCard(storeId);
    }

    function clearMarkers() {
      markersById.forEach(function (entry) {
        entry.marker.remove();
      });
      markersById.clear();
    }

    function setAllSelectValues(selects, value) {
      selects.forEach(function (selectEl) {
        if (selectEl) {
          selectEl.value = value;
        }
      });
    }

    function fitMapToRows(rows) {
      if (!rows.length) {
        map.flyTo({
          center: defaultCenter,
          zoom: defaultZoom,
          essential: true,
        });
        return;
      }

      if (rows.length === 1) {
        map.flyTo({
          center: [rows[0].lng, rows[0].lat],
          zoom: 12,
          essential: true,
        });
        return;
      }

      var bounds = new maplibregl.LngLatBounds();
      rows.forEach(function (row) {
        bounds.extend([row.lng, row.lat]);
      });

      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 12,
        duration: 450,
      });
    }

    function renderCards(rows) {
      cardsEl.innerHTML = "";

      if (!rows.length) {
        setFeedback("No stores found for selected filters.");
        return;
      }

      setFeedback("");

      rows.forEach(function (store, index) {
        var card = buildCard(store, index);

        card.addEventListener("click", function () {
          setActiveCard(store.id);

          var markerEntry = markersById.get(store.id);
          if (markerEntry) {
            map.flyTo({
              center: [store.lng, store.lat],
              zoom: Math.max(map.getZoom(), 15),
              essential: true,
            });
            markerEntry.popup.addTo(map);
          }
        });

        cardsEl.appendChild(card);
      });

      setActiveCard(activeStoreId || rows[0].id);
    }

    function renderMarkers(rows) {
      clearMarkers();

      rows.forEach(function (store) {
        var markerEl = createMarkerElement(store);
        var popup = new maplibregl.Popup({ offset: 16 }).setHTML(
          "<strong>" +
            escapeHtml(store.store_name || "Store") +
            "</strong><br>" +
            escapeHtml(store.city || "-"),
        );

        var marker = new maplibregl.Marker({
          element: markerEl,
          anchor: "center",
        })
          .setLngLat([store.lng, store.lat])
          .setPopup(popup)
          .addTo(map);

        markerEl.addEventListener("click", function () {
          scrollToCard(store.id);
        });

        markersById.set(store.id, { marker: marker, popup: popup });
      });
    }

    function getFilteredRows() {
      var country = activeCountry;
      var city = activeCity;

      return stores.filter(function (store) {
        var countryMatch = country === "all" || store.country === country;
        var cityMatch = city === "all" || store.city === city;
        return countryMatch && cityMatch;
      });
    }

    function syncCityOptions() {
      var country = activeCountry;
      var source =
        country === "all"
          ? stores
          : stores.filter(function (store) {
              return store.country === country;
            });

      cityFilters.forEach(function (cityFilter) {
        setOptions(cityFilter, uniqueValues(source, "city"));
      });

      if (
        !cityFilters.some(function (cityFilter) {
          return cityFilter.value === activeCity;
        })
      ) {
        activeCity = "all";
      }

      setAllSelectValues(cityFilters, activeCity);
    }

    function render() {
      filteredStores = getFilteredRows();
      countEls.forEach(function (countEl) {
        countEl.textContent = filteredStores.length + " Results";
      });

      if (
        filteredStores.length &&
        !filteredStores.some(function (store) {
          return store.id === activeStoreId;
        })
      ) {
        activeStoreId = filteredStores[0].id;
      }

      renderMarkers(filteredStores);
      renderCards(filteredStores);
      fitMapToRows(filteredStores);
    }

    countryFilters.forEach(function (countryFilter) {
      countryFilter.addEventListener("change", function () {
        activeCountry = countryFilter.value || "all";
        setAllSelectValues(countryFilters, activeCountry);
        syncCityOptions();
        render();
      });
    });

    cityFilters.forEach(function (cityFilter) {
      cityFilter.addEventListener("change", function () {
        activeCity = cityFilter.value || "all";
        setAllSelectValues(cityFilters, activeCity);
        render();
      });
    });

    function applyPayload(payload) {
      setLoadingState(false);
      stores = parseStores(payload);

      if (!stores.length) {
        cardsEl.innerHTML = "";
        setFeedback("Store data unavailable");
        countEls.forEach(function (countEl) {
          countEl.textContent = "0 Results";
        });
        return;
      }

      countryFilters.forEach(function (countryFilter) {
        setOptions(countryFilter, uniqueValues(stores, "country"));
      });
      activeCountry = "all";
      setAllSelectValues(countryFilters, activeCountry);
      syncCityOptions();
      activeCity = "all";
      setAllSelectValues(cityFilters, activeCity);
      render();

      setTimeout(function () {
        map.resize();
      }, 150);
    }

    setLoadingState(true);
    fetchStores(apiUrl)
      .then(function (payload) {
        applyPayload(payload);
      })
      .catch(function () {
        setLoadingState(false);
        cardsEl.innerHTML = "";
        setFeedback("Store data unavailable");
        countEls.forEach(function (countEl) {
          countEl.textContent = "0 Results";
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
